
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'SurveyInputPhoneNumber',
  props: {
    modelValue: {
      type: String,
      default: '',
    },

    /**
     * プレースホルダ
     */
    placeholder: {
      type: String,
      default: '入力してください',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // 電話番号は最大 15 桁とする
    // https://www.accumu.jp/vol22-23/%E3%82%84%E3%81%95%E3%81%97%E3%81%9D%E3%81%86%E3%81%AB%E8%A6%8B%E3%81%88%E3%82%8B%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E3%81%AE%E9%9B%A3%E3%81%97%E3%81%95%20%E7%B7%8F%E5%8B%99%E5%A4%A7%E8%87%A3%E8%B3%9E%E3%82%92%E5%8F%97%E8%B3%9E%E3%81%97%E3%81%A6.html#:~:text=%E5%8B%A7%E5%91%8A%E3%81%AB%E3%81%AF%EF%BC%8C%E7%A8%AE%E3%80%85%E3%81%AE,%E6%A1%81%E3%81%BE%E3%81%A7%E4%BD%BF%E7%94%A8%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%99%E3%80%82
    const value = ref(filterNumber(props.modelValue).slice(0, 15));

    /**
     * 入力したとき
     */
    const onInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      value.value = filterNumber(input.value).slice(0, 15);

      onUpdate();
    };

    /**
     * 貼り付けたとき
     */
    const onPaste = (event: ClipboardEvent) => {
      event.preventDefault();
      const text = event.clipboardData?.getData('text') ?? '';
      value.value = filterNumber(text).slice(0, 15);

      onUpdate();
    };

    const onUpdate = () => {
      emit('update:modelValue', value.value);
    };

    /**
     * 数値以外を取り除く
     */
    function filterNumber(value: string) {
      return value.replace(/\D/g, '');
    }

    return {
      value,
      onInput,
      onPaste,
    };
  },
});
